export const OPEN_COMMAND_BUTTON = 'open';
export const CLOSE_COMMAND_BUTTON = 'close';
export const DELETE_COMMAND_BUTTON = 'delete';
export const CANCEL_COMMAND_BUTTON = 'cancel';
export const COMMIT_COMMAND_BUTTON = 'commit';
